module.exports = __webpack_public_path__ + "img/gift-15.62fe92a2.jpg";